// extracted by mini-css-extract-plugin
export default {"cls1":"PremiumButton-cls1___6c68691f04e39b4a309","cls2":"PremiumButton-cls2___fac38857ceaabf3100b PremiumButton-cls1___6c68691f04e39b4a309"};